import { MetaWrapper } from '@components/Meta'
import React from 'react'
import Page from './Page'
import { useTranslation } from 'react-i18next'

const View: React.FC = () => {
  const { t } = useTranslation()
  return (
    <MetaWrapper titleDetails={t('metaTitle.wholesale', 'Wholesale')}>
      <Page />
    </MetaWrapper>
  )
}

export default View
